import Parking from '../../parkings/models/parking';
import { type DayPart } from './daypart-entry';

class ParkingDayPartEntries {
  id?: string;

  dayPart?: DayPart;

  parkingId?: string;

  parking?: Parking;
}

export default ParkingDayPartEntries;
